// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useDataAttributes(props) {
    const dataAttributes = Object.entries(props).reduce((result, [key, value]) => {
        if (key.startsWith('data-')) {
            result[key] = value;
        }
        return result;
    }, {});
    return dataAttributes;
}
export { useDataAttributes };
//# sourceMappingURL=useDataAttributes.js.map